"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _webVitals = require("./web-vitals");
Object.keys(_webVitals).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _webVitals[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _webVitals[key];
    }
  });
});